export default "__VITE_ASSET__ANpGZsgW__"